module.exports = __webpack_public_path__ + "static/media/day_one.c012810c.jpg";